import { Component, Inject, inject, Input, input, OnInit } from '@angular/core';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { ApplicantDetails } from '../../data/applicant-details';
import { Person } from '../../data/person';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { resolvePersonOption } from '../../../helpers/person.helpers';

export class HealthCondition {
  condition: string = '';
  person: Person = new Person();
}

@Component({
  selector: 'app-health-condition-dialog',
  templateUrl: './health-condition-dialog.component.html',
  styleUrl: './health-condition-dialog.component.scss'
})
export class HealthConditionDialogComponent implements OnInit {

  healthCondition!: HealthCondition;
  personOptions: Array<{ value: Person, label: string }> = [];
  formBuilder = inject(NonNullableFormBuilder);
  healthConditionForm = this.formBuilder.group({
    condition: [''],
    person: [null as Person | null]

  });

  constructor(public dialogRef: MatDialogRef<HealthConditionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
   this.healthCondition = data.healthCondition;
   this.personOptions = data.personOptions;

  }

  get dialogTitle(): string {
    return 'Add Health Condition';
  }



  ngOnInit(): void {


    this.initializeForm();
    this.applyValidators();

  }

  private initializeForm(): void{
    this.healthConditionForm.patchValue({
      condition: this.healthCondition.condition,
      person: resolvePersonOption(this.healthCondition.person, this.personOptions)
    });

    this.healthConditionForm.valueChanges.subscribe(formValue => {
      this.healthCondition.condition = formValue.condition || '';
      this.healthCondition.person = formValue.person || new Person();
    });

  }

  private applyValidators(): void {
    const conditionControl = this.healthConditionForm.controls.condition;
    const personControl = this.healthConditionForm.controls.person;
    conditionControl.setValidators([Validators.required]);
    personControl.setValidators([Validators.required]);
    conditionControl.updateValueAndValidity();
    personControl.updateValueAndValidity();
  }

  cancel() {
    this.dialogRef.close();
  }
  ok() {
    if(this.healthConditionForm.valid){
      this.dialogRef.close(this.healthCondition);
    }
    else{
      this.healthConditionForm.markAllAsTouched();
      return;
    }
    
  }







}
